import { render } from "./MemoryRef.vue?vue&type=template&id=3b24485d&scoped=true"
import script from "./MemoryRef.vue?vue&type=script&lang=js"
export * from "./MemoryRef.vue?vue&type=script&lang=js"

import "./MemoryRef.vue?vue&type=style&index=0&id=3b24485d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b24485d"]])

export default __exports__